import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import requestUtil from '../../helpers/requestUtil';
import useConfiguration from '../../hooks/useConfiguration';
import useValidation from '../../hooks/useValidation';
import Loader from '../common/Loader';
import {
  setLoadingPageFalse,
  setLoadingPageTrue,
} from '../common/Loader/action';
import Error from '../common/Message/error';
import Success from '../common/Message/success';
import TextField from '../common/TextField';
import { mapURL } from '../../helpers/domainURL';
import { getInstanceLogo } from '../Instance/instance';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  // const fiveStarDomain = ['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com']
  // const isFiveStar = mapURL.fiveStarDomain.includes(window.location.hostname);
  // const lifeStyleDomain = ['dynamicemployers.overturexl.com']
  // const isLifeStyle = mapURL.lifeStyleDomain.includes(window.location.hostname);
  // const isNurseEtc = mapURL.nursesEtc.includes(window.location.hostname);
  const mainLogo = getInstanceLogo();
  const validate = useValidation();
  const config = useConfiguration();
  const validateEmail = () => {
    const result = validate('forgotPassword', [{ name: 'email', data: email }]);
    if (result.valid) {
      setFormErrors({});
    } else {
      setFormErrors(result.errors);
    }
    return result.valid;
  };
  const gotoLogin = (e) => {
    e.preventDefault();
    navigate('/');
  };
  const resetPassword = (event) => {
    event.preventDefault();
    if (validateEmail()) {
      dispatch(setLoadingPageTrue());
      requestUtil(
        `${config.baseUrl}/Authenticate/employer-forgot-password/${email}/${window.location.hostname}`,
        'POST',
        {}
      )
        .then((response) => {
          setSuccessMessage(response.message);
          dispatch(setLoadingPageFalse());
          setErrorMessage(null);
        })
        .catch((error) => {
          dispatch(setLoadingPageFalse());
          setError(true);
          setErrorMessage(error.message);
          setSuccessMessage(null);
        });
    }
  };
  const updateFormValue = (target) => {
    setEmail(target.value);
  };
  return (
    <div className="page main-background-color ">
      <Loader />
      <div className="">
        <div className="container-login100">
          <div className="wrap-login100 p-6">
            <form className="login100-form validate-form">
              <span className="login100-form-title pb-5">
                <a href="">
                  <img
                 style={{minWidth:"270px", maxHeight:"90px", maxWidth:"280px" }}
                    // style={{ height: isFiveStar && "100px" }}
                    // src="assets/images/brand/Overturecommonlogo.svg"
                    src={mainLogo ? mainLogo :  'assets/images/brand/EMPLOYER.png'}
                    className="header-brand-img"
                    alt=""
                  />
                </a>
              </span>
              <span className="login100-form-title pb-5">Forgot Password</span>
              {errorMessage && <Error errorMessage={errorMessage} />}
              {successMessage && <Success successMessage={successMessage} />}
              <p className="text-muted">
                Enter the email address registered on your account
              </p>
              <TextField
                placeholder={'Email'}
                name={'email'}
                type={'email'}
                iconClass={'zmdi zmdi-email'}
                errors={formErrors['email']}
                updateValue={updateFormValue}
              />
              <div className="submit">
                <a
                  className="btn btn-primary d-grid"
                  href="#"
                  onClick={resetPassword}
                >
                  Send Password Reset Link
                </a>
              </div>
              <div className="text-center mt-4">
                <p className="text-dark mb-0">
                  Got it?
                  <a className="text-primary ms-1" href="#" onClick={gotoLogin}>
                    Login
                  </a>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
